import { ClientEvents } from 'common/events/ClientEvents';
import React from 'react';
import { MealPlanFormat, UpcomingMealPlanGroupOrderFragment } from 'src/gqlReactTypings.generated.d';
import { useHistory } from 'src/shared/hooks/useHistory';
import { useTracker } from 'src/shared/hooks/useTracker';
import { Routes } from 'src/shared/Routes';
import { Container, ContainerWidth } from 'web-common/src/shared/design-system/components/Container';
import { CTAFooter, StickyFooterContainer } from 'web-common/src/shared/design-system/components/StickyFooter';
import { WSSReferralBannerWrapper } from '../../../components/Banners/ReferralBanners/WSSReferralBanner';
import { OrderStatusAndDishCarousel } from './components/OrderStatusAndDishCarousel';

interface ActiveSubscriberPageProps {
  format: MealPlanFormat;
  groupOrder: UpcomingMealPlanGroupOrderFragment;
  unit: number;
  numServings: number;
}

export const ActiveSubscriberPage: React.FC<ActiveSubscriberPageProps> = ({
  groupOrder,
  unit,
  numServings,
  format,
}) => {
  const tracker = useTracker();
  const history = useHistory();
  const navigateToMealPlanUpcomingOrder = () => {
    tracker.track(ClientEvents.WSS_TAB_VIEW_UPCOMING, { location: 'cta' });
    history.push(Routes.CONSUMER_MEAL_PLANS_UPCOMING_ORDER);
  };

  return (
    <div className='mb-14'>
      <OrderStatusAndDishCarousel groupOrder={groupOrder} unit={unit} numServings={numServings} format={format} />
      <div className='my-6'>
        <Container containerWidth={ContainerWidth.Narrow}>
          <WSSReferralBannerWrapper />
        </Container>
      </div>
      <StickyFooterContainer>
        <CTAFooter
          primaryCTACopy='View upcoming order'
          primaryCTAOnClick={navigateToMealPlanUpcomingOrder}
          primaryIconName='arrowRight'
        />
      </StickyFooterContainer>
    </div>
  );
};
